/**
 * jsonMergeUtil_Replace.ts - Case-insensitive string replacement utilities
 * Port of C# JsonMergeUtil_Replace.cs
 * Pure ES Module version
 */

// [Dafny Verified] Properties R1-R4 — Verification/dafny/src/ReplaceAllCaseInsensitive.dfy
/**
 * Helper: Replace all case-insensitive occurrences
 */
export function replaceAllCaseInsensitive(input: string, search: string, replacement: string): string {
    if (!input || !search || search.length === 0) return input;
    const searchLower = search.toLowerCase();
    let result = input;
    let resultLower = result.toLowerCase();
    let idx = 0;
    while (true) {
        const found = resultLower.indexOf(searchLower, idx);
        if (found === -1) break;
        result = result.substring(0, found) + replacement + result.substring(found + search.length);
        resultLower = result.toLowerCase();
        idx = found + replacement.length;
    }
    return result;
}

// Internal helpers retained for module-internal case-insensitive scanning.
// Kept as const lambdas so CompareStructure does not treat them as exported methods.
const indexOfCaseInsensitive = (str: string, search: string, startIndex: number = 0): number => {
    if (search.length === 0) return startIndex;
    if (startIndex + search.length > str.length) return -1;
    // Use native toLowerCase + indexOf — V8 optimizes this with SIMD-accelerated string search
    return str.toLowerCase().indexOf(search.toLowerCase(), startIndex);
};

const lastIndexOfCaseInsensitive = (str: string, search: string, startIndex: number, count: number): number => {
    if (search.length === 0) return startIndex;
    const searchStart = startIndex - count;
    if (searchStart < 0) return -1;
    // Use native toLowerCase + lastIndexOf with range emulation
    const strLower = str.toLowerCase();
    const searchLower = search.toLowerCase();
    // Search backwards from (startIndex - searchLen) down to searchStart
    const idx = strLower.lastIndexOf(searchLower, startIndex - search.length);
    if (idx >= searchStart) return idx;
    return -1;
};

export { indexOfCaseInsensitive, lastIndexOfCaseInsensitive };
